import http from './http'

// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "https://manage.minsuhuipc.com"

// 获取分类
export function getIndexHotHomestayList(params) {
	return http.post(`${resquest}/api/homestay/getIndexHotHomestayList`, params)
}
//首页最新入驻民宿列表 
export function getNewHomestayList(params) {
	return http.post(`${resquest}/api/homestay/getNewHomestayList`, params)
}
//热门城市 
export function hotCityList(params) {
	return http.post(`${resquest}/api/index/hotCityList`, params)
}
//5A景区
export function hotScencyArea(params) {
	return http.post(`${resquest}/api/search/getHotScencyArea`, params)
}
//首页推荐旅行社团列表 
export function getTravelList(params) {
	return http.post(`${resquest}/api/travel/getTravelList`, params)
}
//手机验证码登录-注册 
export function mobilelogin(params) {
	return http.post(`${resquest}/api/user/mobilelogin`, params)
}
//发送验证码 
export function sendCode(params) {
	return http.post(`${resquest}/api/sms/send`, params)
}
//会员账号密码登录 
export function login(params) {
	return http.post(`${resquest}/api/user/login`, params)
}
//修改密码-忘记密码 
export function resetpwd(params) {
	return http.post(`${resquest}/api/user/resetpwd`, params)
}
//民宿详情 
export function getHomestayDetail(params) {
	return http.post(`${resquest}/api/homestay/getHomestayDetail`, params)
}
//民宿评论列表 
export function getCommentList(params) {
	return http.post(`${resquest}/api/comment/getCommentList`, params)
}
//民宿评论提交 
export function commentStore(params) {
	return http.post(`${resquest}/api/comment/commentStore`, params)
}
//民宿评论回复提交 
export function replyStore(params) {
	return http.post(`${resquest}/api/comment/replyStore`, params)
}
//删除评论 
export function delFavorite(params) {
	return http.post(`${resquest}/api/comment/delFavorite`, params)
}
//添加到我的收藏 
export function favoriteStore(params) {
	return http.post(`${resquest}/api/favorite/favoriteStore`, params)
}
//删除收藏 
export function favoriteDelFavorite(params) {
	return http.post(`${resquest}/api/favorite/delFavorite`, params)
}
//会员中心 
export function userInfo(params) {
	return http.post(`${resquest}/api/user/userInfo`, params)
}
//搜索历史列表 
export function searchList(params) {
	return http.post(`${resquest}/api/search/searchList`, params)
}
//添加搜索历史 
export function searchStore(params) {
	return http.post(`${resquest}/api/search/searchStore`, params)
}
//民宿认证提交 
export function homestayStore(params) {
	return http.post(`${resquest}/api/homestay/homestayStore`, params)
}
//获取分类 
export function getCategory(params) {
	return http.post(`${resquest}/api/category/getCategory`, params)
}
//修改会员个人信息 
export function profile(params) {
	return http.post(`${resquest}/api/user/profile`, params)
}
//我的问答列表 
export function myQuestionList(params) {
	return http.post(`${resquest}/api/user/myQuestionList`, params)
}
//我的回答列表 
export function myAnswerList(params) {
	return http.post(`${resquest}/api/user/myAnswerList`, params)
}
//我的民宿管理 
export function myHomestayDetail(params) {
	return http.post(`${resquest}/api/user/myHomestayDetail`, params)
}
//民宿修改提交 
export function myHomestayStore(params) {
	return http.post(`${resquest}/api/user/myHomestayStore`, params)
}
//VIP配置列表 
export function getVipList(params) {
	return http.post(`${resquest}/api/vip/getVipList`, params)
}
//VIP购买发起支付 
export function sendPay(params) {
	return http.post(`${resquest}/api/vip/sendPay`, params)
}
//邀请房东 
export function inviteGiveVipList(params) {
	return http.post(`${resquest}/api/invite_give_vip/inviteGiveVipList`, params)
}
//我的收藏-心愿单列表 
export function getFavoriteList(params) {
	return http.post(`${resquest}/api/favorite/getFavoriteList`, params)
}
//获取公告列表 
export function getNoticeList(params) {
	return http.post(`${resquest}/api/notice/getNoticeList`, params)
}
//公告详情 
export function getNoticeDetail(params) {
	return http.post(`${resquest}/api/notice/getNoticeDetail`, params)
}
//消息通知列表 
export function getSystemMessageList(params) {
	return http.post(`${resquest}/api/system_message/getSystemMessageList`, params)
}
//更改为已读 
export function updateStore(params) {
	return http.post(`${resquest}/api/system_message/updateStore`, params)
}
//更改全部为已读 
export function updateAllStore(params) {
	return http.post(`${resquest}/api/system_message/updateAllStore`, params)
}
//获取是否有未读消息 
export function getSystemMessage(params) {
	return http.post(`${resquest}/api/system_message/getSystemMessage`, params)
}
//获取资讯列表 
export function getNewsList(params) {
	return http.post(`${resquest}/api/news/getNewsList`, params)
}
//资讯详情 
export function getNewsDetail(params) {
	return http.post(`${resquest}/api/news/getNewsDetail`, params)
}
//资讯浏览量增加 
export function addNewsViews(params) {
	return http.post(`${resquest}/api/news/addNewsViews`, params)
}
//获取问答列表 
export function getQuestionList(params) {
	return http.post(`${resquest}/api/question/getQuestionList`, params)
}
//问答详情 
export function getQuestionDetail(params) {
	return http.post(`${resquest}/api/question/getQuestionDetail`, params)
}
//问答浏览量增加 
export function addQuestionViews(params) {
	return http.post(`${resquest}/api/question/addQuestionViews`, params)
}
//问答评论提交 
export function questionAnswerStore(params) {
	return http.post(`${resquest}/api/question/questionAnswerStore`, params)
}
//最新问答列表 
export function getNewestQuestionList(params) {
	return http.post(`${resquest}/api/question/getNewestQuestionList`, params)
}
//发表问答提交 
export function questionStore(params) {
	return http.post(`${resquest}/api/question/questionStore`, params)
}
//社团详情 
export function getTravelDetail(params) {
	return http.post(`${resquest}/api/travel/getTravelDetail`, params)
}
//社团详情你可能还喜欢列表 
export function travelDetailLikeList(params) {
	return http.post(`${resquest}/api/travel/travelDetailLikeList`, params)
}
//社团认证详情 
export function getTravelAuthDetail(params) {
	return http.post(`${resquest}/api/travel_auth/getTravelAuthDetail`, params)
}
//旅行社团认证提交 
export function travelAuthStore(params) {
	return http.post(`${resquest}/api/travel_auth/travelAuthStore`, params)
}
//旅行社团提交 
export function travelStore(params) {
	return http.post(`${resquest}/api/travel/travelStore`, params)
}
//关于我们-页眉-页脚数据 
export function about(params) {
	return http.post(`${resquest}/api/about/about`, params)
}
//获取轮播列表 
export function getBannerList(params) {
	return http.post(`${resquest}/api/banner/getBannerList`, params)
}
//友情链接 
export function getFriendlyLink(params) {
	return http.post(`${resquest}/api/about/getFriendlyLink`, params)
}
//民宿列表 
export function getHomestayList(params) {
	return http.post(`${resquest}/api/homestay/getHomestayList`, params)
}
//增加浏览量
export function addHomestayViews(params) {
	return http.post(`${resquest}/api/homestay/addHomestayViews`, params)
}
//支付订单查询
export function getPayResult(params) {
	return http.post(`${resquest}/api/vip/getPayResult`, params)
}
//vip到期提醒
export function remindHomestay(params) {
	return http.post(`${resquest}/api/homestay/remindHomestay`, params)
}
//获取广告列表 
export function getSpecialList(params) {
	return http.post(`${resquest}/api/special/getSpecialList`, params)
}
//绑定手机号
export function bindMobile(params){
	return http.post(`${resquest}/api/login/app_weixin_bind_mobile`,params)
}
//微信扫码登录
export function scanQrcode(params){
	return http.post(`${resquest}/api/login/pc_weixin`,params)
}

//获取城市分类
export function cityTypeList(params){
	return http.post(`${resquest}/api/index/cityTypeList`,params)
}
//获取类别
export function getCategoryTypeList(params){
	return http.post(`${resquest}/api/index/getCategoryType`,params)
}


// WEBPACK FOOTER //
// ./src/request/api.js